<p-dialog
  [header]="'common.comment' | transloco"
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [modal]="true"
  appendTo="body"
  [style]="{width: 'min(900px, 95vw)', height: '600px'}"
  [breakpoints]="{'960px': '95vw', '640px': '95vw'}"
  [draggable]="false"
  [resizable]="false"
  contentStyleClass="flex flex-col h-full"
  (onHide)="close()"
>
  <div class="flex flex-col h-full gap-4">
    <div class="flex-1">
      <textarea
        pTextarea
        [ngModel]="commentContainer().comment"
        (ngModelChange)="!isReadOnly() && (commentContainer().comment = $event)"
        class="w-full h-full resize-none"
        [placeholder]="placeholderKey() | transloco"
        [disabled]="isReadOnly()"
      ></textarea>
    </div>

    <div class="flex justify-end gap-2">
      @if (!isReadOnly()) {
        <p-button
          [label]="'common.delete' | transloco"
          icon="pi pi-trash"
          severity="secondary"
          (onClick)="clearComment()"
          [disabled]="!commentContainer().comment?.trim()"
        />
      }
      <p-button
        [label]="(isReadOnly() ? 'common.close' : 'common.confirm') | transloco"
        icon="pi pi-check"
        (onClick)="sendComment()"
        [disabled]="!isReadOnly() && !commentContainer().comment?.trim()"
      />
    </div>
  </div>
</p-dialog>
